import { Injectable } from '@angular/core';
import { Analise, Projeto } from '../models/analise';
import { AppUserService } from './app-user.service';

/**
 * Serviço de envio de dados do componente dashboard para map.
 */
@Injectable({
  providedIn: 'root'
})
export class DashboardToMapService {

  /** Referência à análise clicada para visualização no dashboard. Usado
   * para inicializar os campos de controle das camadas na tela do mapa.
   */
  fowardedAnalise: Analise;

  /** Referência à análise sendo editada, e possivelmente salva na tela do mapa. */
  currAnalise: Analise;

  /** Indica se o acesso ao componente do mapa foi roteado pelo botão
   * da análise no dashboard ou não.
   */
  routed = false;

  constructor() {}

  /**
   * Define a referência à análise encaminhada.
   * 
   * @param analise análise clicada para visualização no dashboard. Será definida como a análise encaminhada.
   */
  setAnalise(analise:Analise){
    this.fowardedAnalise = analise;
  }

  /**
   * Define a referência à análise encaminhada, e o valor
   * routed como true.
   * @param analise análise clicada para visualização no dashboard.
   */
  setRouterInformation(analise:Analise){
    this.setAnalise(analise);
    this.routed = true;
  }

  /**
   * Obtém a referência à análise encaminhada, e define o valor do
   * atributo routed como false.
   * @returns referência à análise que foi enviada do dashboard pelo click no botão de visualizar a análise.
   */
  getRouterInformation() : Analise{
    this.routed = false;
    return this.fowardedAnalise
  }
}
